import { BREAKPOINT700 } from 'constants.js';

const styles = ({ login: { backgroundColor }, palette: { primary }, spacing }) => ({
  background: { backgroundColor, width: '100%' },
  container: {
    backgroundColor,
    margin: '0 auto',
    minHeight: '100vh',
    maxWidth: 676,
    overflow: 'auto',
    paddingTop: spacing.unit * 5,
    width: 676,
    [`@media only screen and (max-width: ${BREAKPOINT700}px)`]: {
      width: 'initial'
    }
  },
  login: {
    border: `3px solid ${primary.light || 'transparent'}`,
    display: 'flex',
    [`@media only screen and (max-width: ${BREAKPOINT700}px)`]: {
      flexDirection: 'column'
    }
  }
});

export default styles;
